export default (total1, total2, total3, total4, total5) => {
  const totalVotes = total1 + total2 + total3 + total4 + total5
  return totalVotes > 0
    ? +parseFloat((total5 * 5 + total4 * 4 + total3 * 3 + total2 * 2 + total1) / totalVotes).toFixed(1)
    : 0
}
